/* src/app/modules/subscription/confirm-plan-dialog/confirm-plan-dialog.component.css */
.confirm-plan-dialog {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 28px 32px 28px;
  max-width: 440px;
  text-align: center;
}
.dialog-title {
  margin: 0 0 8px;
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
}
.dialog-subtitle {
  margin: 0 0 24px;
  color: #64748b;
  font-size: 0.95rem;
}
.plan-summary {
  width: 100%;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;
}
.plan-name-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 7px 0;
  font-size: 0.92rem;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}
.plan-name-row:last-child {
  border-bottom: none;
}
.plan-label {
  color: #64748b;
}
.plan-value {
  font-weight: 600;
  color: #0f172a;
}
.discount-value {
  color: #16a34a;
}
.plan-total-row {
  margin-top: 4px;
  padding-top: 12px;
}
.total-value {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--cf-brand-dark);
}
.billing-note {
  font-size: 0.8rem;
  color: #94a3b8;
  margin: 0 0 24px;
}
.dialog-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
}
.btn-back {
  display: flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #cbd5e1;
  background: #fff;
  color: #334155;
  border-radius: 8px;
  padding: 10px 18px;
  font-weight: 600;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.15s;
}
.btn-back:hover {
  background: #f8fafc;
}
.btn-back mat-icon,
.btn-confirm mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.btn-confirm {
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: var(--cf-brand-dark);
  color: #fff;
  border-radius: 8px;
  padding: 10px 22px;
  font-weight: 700;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.15s;
  flex: 1;
  justify-content: center;
}
.btn-confirm:hover {
  background: var(--cf-brand-dark);
}
.btn-confirm:disabled {
  opacity: 0.6;
  cursor: default;
}
/*# sourceMappingURL=confirm-plan-dialog.component.css.map */
